/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyDocusignIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-docusign" */ './utils').then((m) => m.DocusignIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/docusign/icon' },
);

const LazyDocusignSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-docusign-search-result" */ './utils').then(
			(m) => m.DocusignSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/docusign/search-result-icon' },
);

const LazyDocusignIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-docusign-borderless" */ './utils').then(
			(m) => m.DocusignIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/docusign/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const DocusignIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyDocusignIconComponent />
	</Suspense>
);

export const DocusignSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyDocusignSearchResultIconComponent />
	</Suspense>
);

export const DocusignIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyDocusignIconBorderlessComponent />
	</Suspense>
);
